export default __webpack_public_path__ + "static/media/cpf.8ac1db89.png";